// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1Ilay","shim":"style_shim__1WOcC","fluidLayoutItem":"style_fluidLayoutItem__NAWKm","bounce":"style_bounce__3onTn"};